export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-100/80 via-accent-100/50 to-secondary-100/60 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-background-50/80 text-primary-700 text-xs font-medium mb-4">
              APP下载
            </span>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              随时随地，畅享漫画
            </h2>
            <p className="text-foreground-600 text-sm leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              下载樱花漫画移动客户端，享受更流畅的下拉式阅读体验。离线缓存、夜间模式、更新推送，漫画世界尽在掌中。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <div className="flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-900 text-background-50 cursor-pointer hover:bg-foreground-800 transition-colors whitespace-nowrap">
                <i className="ri-apple-fill text-lg"></i>
                <div className="text-left">
                  <div className="text-[10px] leading-tight opacity-70">Download on the</div>
                  <div className="text-sm font-semibold leading-tight">App Store</div>
                </div>
              </div>
              <div className="flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-900 text-background-50 cursor-pointer hover:bg-foreground-800 transition-colors whitespace-nowrap">
                <i className="ri-google-play-fill text-lg"></i>
                <div className="text-left">
                  <div className="text-[10px] leading-tight opacity-70">GET IT ON</div>
                  <div className="text-sm font-semibold leading-tight">Google Play</div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="w-48 h-48 md:w-56 md:h-56 rounded-3xl bg-background-50 border-4 border-background-200/70 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20clean%20modern%20mobile%20app%20mockup%20displaying%20colorful%20manga%20reading%20interface%20on%20a%20smartphone%20screen%2C%20warm%20cream%20background%2C%20soft%20lighting%2C%20minimal%20design%2C%20manga%20reader%20UI%20with%20Korean%20webtoon%20style%20art%2C%20cherry%20blossom%20accent%2C%20editorial%20quality&width=560&height=560&seq=app-manga-01&orientation=squarish"
                alt="樱花漫画APP - 手机端下拉式阅读体验"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}